import { useExtensionList } from '@confluence/forge-ui/entry-points/useExtensionList.ts';
import { FORGE_MODULE_HOMEPAGE_FEED } from '@confluence/forge-ui/entry-points/ForgeModuleType.ts';

const useForgeAppsVisible = () => {
	const { extensions } = useExtensionList({
		moduleType: FORGE_MODULE_HOMEPAGE_FEED,
	});

	return Array.isArray(extensions) && extensions.length > 0;
};

export const useRightPanelVisible = (): {
	shouldShowRightPanel: boolean;
	shouldShowForgeApps: boolean;
} => {
	const shouldShowForgeApps = useForgeAppsVisible();

	const shouldShowRightPanel = shouldShowForgeApps;

	return {
		shouldShowRightPanel,
		shouldShowForgeApps,
	};
};
